export default __webpack_public_path__ + "static/media/Medico-Desk.608244b4.jpg";